import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';
import { IInstructionDTO } from '../../dto/instruction/instruction.dto';
import {
  NzListComponent,
  NzListFooterComponent,
  NzListHeaderComponent,
  NzListItemComponent,
  NzListItemMetaComponent,
  NzListItemMetaTitleComponent,
} from 'ng-zorro-antd/list';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzTypographyComponent } from 'ng-zorro-antd/typography';
import { NgClass } from '@angular/common';
import { getIndexClass } from '../../util/index.util';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-instruction',
  imports: [
    NzListComponent,
    NzListItemComponent,
    NzRowDirective,
    NzColDirective,
    NzTypographyComponent,
    NzListHeaderComponent,
    NzListFooterComponent,
    NzListItemMetaComponent,
    NzListItemMetaTitleComponent,
    NgClass,
  ],
  templateUrl: './instruction.component.html',
  styleUrl: './instruction.component.less',
})
export class InstructionComponent {
  public readonly instructionDTO: InputSignal<IInstructionDTO> =
    input.required<IInstructionDTO>();

  public getIndexClass: (index: number) => string = getIndexClass;
}
